// extracted by mini-css-extract-plugin
export var activeDot = "_8m-c";
export var buttonContainer = "_8m-9";
export var channelButton = "_8m-a";
export var clickable = "_8m-d";
export var content = "_8m-0";
export var contentFull = "_8m-2";
export var contentThird = "_8m-1";
export var contentWrapper = "_8m-7";
export var description = "_8m-5";
export var heightShort = "_8m-f";
export var image = "_8m-3";
export var imageContainer = "_8m-4";
export var selectButton = "_8m-e";
export var spinnerContainer = "_8m-b";
export var titleContent = "_8m-8";
export var titleWrapper = "_8m-6";